import { Accordion } from '../../../../../components/general/accordion';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Table } from '../../../../../components/general/table';
import { usePqrSmartHistory } from './hook';
import { PqrSmartHistoryProps } from './props';

export const PqrSmartHistory = (props: PqrSmartHistoryProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrSmartHistory(props);

    return (
        <Accordion
            title="HISTÓRICO SMARTSUPERVISION"
            icon={<ReceiptLongIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
